import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "get-started-with-exoclick-ads-for-react"
    }}>{`Get started with ExoClick ads for React`}</h1>
    <p><inlineCode parentName="p">{`exoclick-react`}</inlineCode>{` is a library to use ExoClick's ads in `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react"
      }}>{`React`}</a>{`. It is designed to
be easy to use and very light.`}</p>
    <p>{`You can try each ad type right here on the component's playgrounds. To go to production, you'll need a publisher account
with ExoClick. You can `}<a parentName="p" {...{
        "href": "https://www.exoclick.com/signup/?login=tomhooijenga"
      }}>{`register here`}</a>{`.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install exoclick-react
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add exoclick-react
`}</code></pre>
    <h2 {...{
      "id": "use"
    }}>{`Use`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Banner } from "exoclick-react";

<Banner zoneId={123} />
`}</code></pre>
    <p>{`That's it!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      